<template>
  <el-dialog
    title="选择用户"
    :visible.sync="dialogVisible"
    width="70%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="closeDialog"
  >
    <div class="user-select-container">
      <!-- 搜索区域 -->
      <div class="search-area">
        <el-form :model="searchForm" size="small" inline>
          <el-form-item label="用户ID">
            <el-input v-model="searchForm.user_id" placeholder="用户ID" clearable></el-input>
          </el-form-item>
          <el-form-item label="昵称">
            <el-input v-model="searchForm.nickname" placeholder="用户昵称" clearable></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="searchForm.mobile" placeholder="手机号码" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getDataList">搜索</el-button>
            <el-button @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 用户列表 -->
      <div class="user-list">
        <el-table
          :data="userList"
          stripe
          style="width: 100%"
          @selection-change="handleSelectionChange"
          v-loading="loading"
        >
          <el-table-column
            v-if="multi"
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            prop="user_id"
            label="用户ID"
            width="100">
          </el-table-column>
          <el-table-column
            label="头像"
            width="80">
            <template slot-scope="scope">
              <img :src="scope.row.avatarUrl || '/static/images/default_avatar.png'" class="user-avatar" />
            </template>
          </el-table-column>
          <el-table-column
            prop="nickName"
            label="昵称"
            min-width="120">
          </el-table-column>
          <el-table-column
            prop="mobile"
            label="手机号"
            width="130">
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="注册时间"
            width="160">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="80">
            <template slot-scope="scope">
              <el-button @click="selectUser(scope.row)" type="text" size="small">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>

      <!-- 底部按钮 - 只在多选模式下显示 -->
      <div slot="footer" class="dialog-footer" v-if="multi">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="confirmSelect" :disabled="selectedUsers.length === 0">确 定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import UserApi from '@/api/user.js';

export default {
  name: 'UserSelect',
  props: {
    is_open: {
      type: Boolean,
      default: false
    },
    multi: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      searchForm: {
        user_id: '',
        nickname: '',
        mobile: ''
      },
      userList: [],
      selectedUsers: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false
    };
  },
  watch: {
    is_open: {
      immediate: true,
      handler(newVal) {
        this.dialogVisible = newVal;
        if (newVal) {
          this.getDataList();
        }
      }
    }
  },
  methods: {
    // 获取用户列表
    getDataList() {
      this.loading = true;
      const params = {
        page: this.currentPage,
        list_rows: this.pageSize,
        ...this.searchForm
      };

      UserApi.userlist(params, true)
        .then(res => {
          this.userList = res.data.list.data || [];
          this.total = res.data.total || 0;
          this.loading = false;
        })
        .catch(error => {
          console.error('获取用户列表失败:', error);
          this.loading = false;
        });
    },

    // 重置搜索条件
    resetSearch() {
      this.searchForm = {
        user_id: '',
        nickname: '',
        mobile: ''
      };
      this.currentPage = 1;
      this.getDataList();
    },

    // 处理选择变化
    handleSelectionChange(selection) {
      this.selectedUsers = selection;
    },

    // 选择单个用户
    selectUser(user) {
      if (this.multi) {
        // 多选模式下切换选择状态
        const index = this.selectedUsers.findIndex(item => item.user_id === user.user_id);
        if (index === -1) {
          this.selectedUsers.push(user);
        } else {
          this.selectedUsers.splice(index, 1);
        }
      } else {
        // 单选模式下直接选择并关闭弹窗
        this.selectedUsers = [user];
        this.confirmSelect();
      }
    },

    // 确认选择
    confirmSelect() {
      if (this.selectedUsers.length === 0) {
        this.$message.warning('请至少选择一个用户');
        return;
      }

      // 发射close事件，包含类型和参数
      this.$emit('close', {
        type: 'success',
        params: this.multi ? this.selectedUsers : this.selectedUsers[0]
      });
      this.dialogVisible = false;
    },

    // 取消选择时
    closeDialog() {
      this.$emit('close', {
        type: 'cancel'
      });
    },

    // 分页大小改变
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getDataList();
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getDataList();
    }
  }
};
</script>

<style scoped>
.user-select-container {
  padding: 10px 0;
}

.search-area {
  margin-bottom: 20px;
}

.user-list {
  margin-bottom: 20px;
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.pagination {
  text-align: right;
  margin-top: 20px;
}

.dialog-footer {
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/user/Select.vue